import { render } from "./RequestsPagination.vue?vue&type=template&id=4ba960e7&scoped=true"
import script from "./RequestsPagination.vue?vue&type=script&lang=js"
export * from "./RequestsPagination.vue?vue&type=script&lang=js"

import "./RequestsPagination.vue?vue&type=style&index=0&id=4ba960e7&lang=scss&scoped=true"

import exportComponent from "/var/www/fgc-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ba960e7"]])

export default __exports__